// Canonical Indian city → state map for the HCAHPS leaderboard.
// Kept close to the leaderboard so it's obvious where to extend it.

export const CITY_TO_STATE = {
  Mumbai: "Maharashtra",
  Pune: "Maharashtra",
  Nagpur: "Maharashtra",
  Nashik: "Maharashtra",
  Aurangabad: "Maharashtra",
  Delhi: "Delhi",
  "New Delhi": "Delhi",
  Gurugram: "Haryana",
  Gurgaon: "Haryana",
  Faridabad: "Haryana",
  Noida: "Uttar Pradesh",
  Ghaziabad: "Uttar Pradesh",
  Lucknow: "Uttar Pradesh",
  Kanpur: "Uttar Pradesh",
  Varanasi: "Uttar Pradesh",
  Agra: "Uttar Pradesh",
  Bengaluru: "Karnataka",
  Bangalore: "Karnataka",
  Mysuru: "Karnataka",
  Mysore: "Karnataka",
  Mangalore: "Karnataka",
  Chennai: "Tamil Nadu",
  Coimbatore: "Tamil Nadu",
  Madurai: "Tamil Nadu",
  Salem: "Tamil Nadu",
  Hyderabad: "Telangana",
  Warangal: "Telangana",
  Visakhapatnam: "Andhra Pradesh",
  Vijayawada: "Andhra Pradesh",
  Tirupati: "Andhra Pradesh",
  Kolkata: "West Bengal",
  Howrah: "West Bengal",
  Siliguri: "West Bengal",
  Ahmedabad: "Gujarat",
  Surat: "Gujarat",
  Vadodara: "Gujarat",
  Rajkot: "Gujarat",
  Kochi: "Kerala",
  Thiruvananthapuram: "Kerala",
  Kozhikode: "Kerala",
  Thrissur: "Kerala",
  Jaipur: "Rajasthan",
  Udaipur: "Rajasthan",
  Jodhpur: "Rajasthan",
  Bhopal: "Madhya Pradesh",
  Indore: "Madhya Pradesh",
  Gwalior: "Madhya Pradesh",
  Chandigarh: "Chandigarh",
  Ludhiana: "Punjab",
  Amritsar: "Punjab",
  Jalandhar: "Punjab",
  Patna: "Bihar",
  Ranchi: "Jharkhand",
  Jamshedpur: "Jharkhand",
  Bhubaneswar: "Odisha",
  Cuttack: "Odisha",
  Guwahati: "Assam",
  Dehradun: "Uttarakhand",
  Shimla: "Himachal Pradesh",
  Srinagar: "Jammu and Kashmir",
  Jammu: "Jammu and Kashmir",
  Panaji: "Goa",
};

export function stateForCity(city) {
  if (!city) return "Other";
  return CITY_TO_STATE[city] || "Other";
}
